import { formatRelativeTimeLabel } from "../../timestampFormat";

/**
 * The picker header line for a stopped Environment's last-known inventory:
 * how old the catalog is, never whether it is too old to use. There is no
 * staleness cutoff — a ten-day-old catalog still lists its models, it just
 * says so.
 *
 * Reuses the sidebar's own relative-time formatter rather than a second one,
 * so the same span reads the same word everywhere in Forge: a thread card
 * showing "3h ago" and this header showing "3h ago" for the same instant
 * cannot drift apart.
 *
 * Returns null when there is no last-known publish time, meaning the
 * inventory is live and there is nothing to date.
 */
export function resolveLastKnownInventoryAgeLabel(input: {
  readonly lastKnownInventoryPublishedAt: string | null;
}): string | null {
  if (input.lastKnownInventoryPublishedAt === null) return null;
  return `Models as of ${formatRelativeTimeLabel(input.lastKnownInventoryPublishedAt)}`;
}
